<script lang="ts">

    import {
        redirectTo,
        historyNavigation,
        storeCurRoute,
    } from "../scripts/router1";
    import {
        idPageHome,
        idPageLogin,
        idPageEntreprises,
        idPageMembres,
        idPageUserAccount,
        idPageNosChantiers,
        idPageNosLivrables,
        idPageEcosystem,
        idPageDevenirPartenaire,
        idPageModifPassword,
        idPageDevenirMembre,
        idPageBlog,
        idPageArticle,
        idPageMyArticles,
        idPageNosPartenaires,
        idPageNosPartenairesFormations,
        namePageHome,
        namePageEntreprises,
        namePageMembres,
        namePageLogin,
        namePageNosChantiers,
        namePageNosLivrables,
        namePageEcosystem,
        namePageDevenirPartenaire,
        namePageDevenirMembre,
        namePageBlog,
        namePageNosPartenaires,
        namePageNosPartenairesFormations,
    } from "../scripts/router2";
    import { storeIsLogin, storeUserLogin } from "../scripts/user";
    import { storeLanguage, lang_en, lang_fr } from "../scripts/store";
    import { eraseCookie, launchLoader } from "../scripts/utils";

    export let isBurgerTwoLines: boolean = false;

    let isOpenBurger: boolean = false;
    let isSubMenuClicked: boolean = false;

    /**
     * burgerToggle
     * @param event
     */
    function burgerToggle(event) {
        if (getComputedStyle(document.getElementById("id_burger")).display != "none") {
            isOpenBurger = !isOpenBurger;
        }
    }

    /**
     * hideSubMenu
     */
    function hideSubMenu(): void {
        isSubMenuClicked = true;
        setTimeout(() => {isSubMenuClicked = false}, 1000);
    }

    /**
     * selectMenu
     * @param menuSelected
     */
    function selectMenu(menuSelected: string, tempo: number = 0) {
        if (tempo > 0) {
            launchLoader(tempo);
        }
        setTimeout(() => redirectTo(menuSelected), tempo);
        hideSubMenu();
    }

    /**
     * disconnect
     */
    function disconnect() {
        redirectTo(idPageHome);
        eraseCookie("cat-login");
        storeIsLogin.set(false);
    }

    /**
     * toggleLang
     */
    function toggleLang() {
        if ($storeLanguage == $lang_en) {
            storeLanguage.set($lang_fr);
        } else {
            storeLanguage.set($lang_en);
        }
    }

    let previousTop: number = 100000;
    let decreaseMenu: boolean = false;
    const startDecrease: number = 100;
    /**
     * expandDecrease
     * 
     * Détection du sens du scroll
     * Si vers le haut alors afficher le sous-menu
     * Si vers le vas alors masquer le sous-menu
     */
     function expandDecrease() {
        var currentTop = window.scrollY;
        if (currentTop < previousTop && currentTop < startDecrease) {
            // go up
            decreaseMenu = false;
        } else {
            // go down
            decreaseMenu = true;
        }
        previousTop = currentTop;
    }

</script>
  
  
<style lang="scss">

    $color_navigation_bg: $color_white;
    $color_navigation: $color_black;
    $color_menu_bg: $color_white;
    $color_menu: $color_black;
    $color_menu_item: $color_black;
    $color_menu_item_hover: $color_orange;
    $color_menu_item_active: $color_primary;

    $menu_decrease_height: 130px;
    $decrease: -70px;

    /* burger */

    $burger_size_a: 7px;
    $burger_size_b: 2px;
    $burger_size_V: 34px;
    $burger_size_c: 9px;
    $burger_size_d: 16px;
    $burger_size_H: 34px;
    $burger_size_top_tY: 9px;
    $burger_size_bottom_tY: -9px;

    .burger {
        position: fixed;
        top: 20px;
        left: 20px;
        height: $burger_size_H;
        width: $burger_size_V;
        border-radius: 50%;
        border: $burger_size_b solid $color_primary;
        cursor: pointer;
        z-index: 1000;
        &__lineTop, &__lineBottom {
            height: $burger_size_b;
            width: $burger_size_d;
            margin: $burger_size_a $burger_size_c;
            background-color: $color_orange;
            transition: 0.4s;
        }
        &__lineMiddle {
            height: $burger_size_b;
            width: $burger_size_d;
            margin: $burger_size_a $burger_size_c;
            background-color: $color_orange;
            transition: 0.4s;
        }
        &__lineTop--open {
            height: $burger_size_b;
            width: $burger_size_d;
            margin: $burger_size_a $burger_size_c;
            background-color: $color_orange;
            transition: 0.4s;
            transform: translateY($burger_size_top_tY) rotate(-45deg);    
        }
        &__lineMiddle--open {
            height: $burger_size_b;
            width: $burger_size_d;
            margin: $burger_size_a $burger_size_c;
            background-color: $color_orange;
            transition: 0.4s;
            opacity: 0;
        }
        &__lineBottom--open {
            height: $burger_size_b;
            width: $burger_size_d;
            margin: $burger_size_a $burger_size_c;
            background-color: $color_orange;
            transition: 0.4s;
            transform: translateY($burger_size_bottom_tY) rotate(45deg);
        }
    }

    /* burger 2 lignes*/

    $burger2_size_a: 6px;
    $burger2_size_b: 2px;
    $burger2_size_V: 30px;
    $burger2_size_c: 9px;
    $burger2_size_d: 29px;
    $burger2_size_H: 47px;
    $burger2_size_top_tY: 4px;
    $burger2_size_bottom_tY: -4px;

    .burger2 {
        position: fixed;
        top: 20px;
        left: 20px;
        height: $burger2_size_H;
        width: $burger2_size_V;
        cursor: pointer;
        z-index: 1000;
        &__lineTop, &__lineBottom {
            height: $burger2_size_b;
            width: $burger2_size_d;
            margin: $burger2_size_a $burger2_size_c;
            background-color: $color_menu;
            transition: 0.4s;
        }
        &__lineTop--open {
            height: $burger2_size_b;
            width: $burger2_size_d;
            margin: $burger2_size_a $burger2_size_c;
            background-color: $color_menu;
            transition: 0.4s;
            transform: translateY($burger2_size_top_tY) rotate(-45deg);    
        }
        &__lineBottom--open {
            height: $burger2_size_b;
            width: $burger2_size_d;
            margin: $burger2_size_a $burger2_size_c;
            background-color: $color_menu;
            transition: 0.4s;
            transform: translateY($burger2_size_bottom_tY) rotate(45deg);
        }
    }

    .navigation {
        z-index: 100;
        transition: transform .5s;
        position: fixed;
        top: 0px;
        padding: 50px 0 200% 0;
        width: 100%;
        transform: translateX(-640px);
        background-color: $color_navigation_bg;
        color: $color_navigation;
        border-radius: 4px;
        &--open {
            transform: translateX(0px);
        }
    }

    .menu {
        margin: 20px 40px 20px 40px;
        list-style-type: none;
        &__item {
            padding: 0 0 12px 0;
            &__img {
                height: 15px;
            }
        }
        &__spacer {
            display: none;
        }
    }

    .subMenu {
        margin: 0px 40px 0px 40px;
        list-style-type: none;
        &__item {
            padding: 8px 0 0 0;
        }
        &__spacer {
            display: none;
        }
    }

    .logo {
        display: none;
    }


    @include medium {
        .navigation {
            transform: translateX(-1024px);
            &--open {
                transform: translateX(0px);
            }
        }
    }

    @include large {
        .burger {
            display: none;
        }

        .burger2 {
            display: none;
        }

        .menuDecrease {
            width: 100%;
            background-color: $color_white;
            transition: transform 1s;
            height: $menu_decrease_height;
            position: fixed;
            top: 0px;
            left: 0px;
            &--decrease {
                transform: translateY($decrease);
            }
        }

        .navigation {
            z-index: 100;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            position: initial;
            padding: 0 0 0 0;
            width: 100%;
            max-width: 100%;
            transform: none;
            background-color: $color_menu_bg;
            border-radius: 0px;
            color: $color_navigation;
        }

        .logo {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-content: center;
            width: 100%;
            margin: 16px 0 16px 0;
            &__img {
                height: 50px;
            }
        }

        .menu {
            width: 100%;
            height: 100%;
            padding: 0;
            display: flex;
            justify-content: space-around;
            flex-direction: column;
            align-items: center;
            margin: 20px 40px 0 40px;
            background-color: $color_menu_bg;
            color: $color_menu;
            &:hover .subMenu {
                max-height: 250%;
                &--clicked {
                    display: none;
                }
            }
            &__item {
                padding: 0 4px 20px 4px;
                position: relative;
                white-space: nowrap;
                color: $color_menu_item;
                cursor: pointer;
                &--active {
                    color: $color_menu_item_active;
                }
                &:hover {
                    color: $color_menu_item_hover;
                }
                &__notclic {
                    cursor: default;
                }
            }
            &__spacer {
                color: $color_menu_item;
                padding: 0 4px 0 4px;
                display: inline;
                white-space: nowrap;
            }
        }

        .subMenu {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            background-color: $color_menu_bg;
            color: $color_menu;
            position: absolute;
            top: 145px;
            margin: 0 0 0 0;
            max-height: 0;
            overflow: hidden;
            transition: max-height 0.6s ease-in-out ;
            border-radius: 0 0 4px 4px;
            &__last {
                left: -130px;
            }
            &__item {
                margin: 8px 32px 8px 32px;
                white-space: nowrap;
                height: 100%;
                overflow: hidden;
                cursor: pointer;
                &--active {
                    color: $color_menu_item_active;
                }
                &:hover {
                    color: $color_menu_item_hover;
                }
            }
            &__spacer {
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                &__line {
                    margin: 0 0 0 32px;
                    background-color: $color_orange;
                    border-radius: 2px;
                    width: 30px;
                    height: 4px;
                }
            }
        }
    }


</style>

<svelte:window on:popstate|preventDefault={historyNavigation} on:scroll={expandDecrease} />
{#if isBurgerTwoLines}
    <div id="id_burger" class="burger2" on:click={burgerToggle} on:keydown={burgerToggle}>
        <div class="{isOpenBurger ? 'burger2__lineTop--open' : 'burger2__lineTop'}"></div>
        <div class="{isOpenBurger ? 'burger2__lineBottom--open' : 'burger2__lineBottom'}"></div>
    </div>
{:else}
    <div id="id_burger" class="burger" on:click={burgerToggle} on:keydown={burgerToggle}>
        <div class="{isOpenBurger ? 'burger__lineTop--open' : 'burger__lineTop'}"></div>
        <div class="{isOpenBurger ? 'burger__lineMiddle--open' : 'burger__lineMiddle'}"></div>
        <div class="{isOpenBurger ? 'burger__lineBottom--open' : 'burger__lineBottom'}"></div>
    </div>
{/if}  

<div class="menuDecrease" class:menuDecrease--decrease={decreaseMenu}>
    <div class="logo"><img class="logo__img" src="../assets/images/logo.svg" alt="logo"></div>
    <nav class="{isOpenBurger ? 'navigation font__h4 navigation--open' : 'navigation font__h4'}" on:click={burgerToggle} on:keydown={burgerToggle}>
        <div class="menu">
            <div class="menu__item" class:menu__item--active={$storeCurRoute == idPageHome} on:click={() => selectMenu(idPageHome)} on:keydown={() => selectMenu(idPageHome)}>
                {#if ($storeLanguage == $lang_fr)}
                {namePageHome}
                {:else}
                Home
                {/if}
            </div>
        </div>
        <div class="menu">
            <div class="menu__item menu__item__notclic">
                {#if ($storeLanguage == $lang_fr)}
                Notre collectif
                {:else}
                Our collective
                {/if}
            </div>
            <div class="{isSubMenuClicked ? 'subMenu subMenu--clicked' : 'subMenu'}">
                <div class="subMenu__spacer">
                    <div class="subMenu__spacer__line">&nbsp;</div>
                </div>
                <div class="subMenu__item" class:subMenu__item--active={$storeCurRoute == idPageEntreprises} on:click={() => selectMenu(idPageEntreprises)} on:keydown={() => selectMenu(idPageEntreprises)}>
                    {#if ($storeLanguage == $lang_fr)}
                    {namePageEntreprises}
                    {:else}
                    Our companies
                    {/if}
                </div>
                <div class="subMenu__item" class:subMenu__item--active={$storeCurRoute == idPageMembres} on:click={() => selectMenu(idPageMembres)} on:keydown={() => selectMenu(idPageMembres)}>
                    {#if ($storeLanguage == $lang_fr)}
                    {namePageMembres}
                    {:else}
                    Our members
                    {/if}
                </div>
                <div class="subMenu__item" class:subMenu__item--active={$storeCurRoute == idPageNosChantiers} on:click={() => selectMenu(idPageNosChantiers)} on:keydown={() => selectMenu(idPageNosChantiers)}>
                    {#if ($storeLanguage == $lang_fr)}
                    {namePageNosChantiers}
                    {:else}
                    Our projects
                    {/if}
                </div>
                <div class="subMenu__item" class:subMenu__item--active={$storeCurRoute == idPageNosLivrables} on:click={() => selectMenu(idPageNosLivrables)} on:keydown={() => selectMenu(idPageNosLivrables)}>
                    {#if ($storeLanguage == $lang_fr)}
                    {namePageNosLivrables}
                    {:else}
                    Our deliverables
                    {/if}
                </div>
                <div class="subMenu__item" class:subMenu__item--active={$storeCurRoute == idPageNosPartenaires} on:click={() => selectMenu(idPageNosPartenaires)} on:keydown={() => selectMenu(idPageNosPartenaires)}>
                    {#if ($storeLanguage == $lang_fr)}
                    {namePageNosPartenaires}
                    {:else}
                    Our partners
                    {/if}
                </div>
                <div class="subMenu__item" class:subMenu__item--active={$storeCurRoute == idPageNosPartenairesFormations} on:click={() => selectMenu(idPageNosPartenairesFormations)} on:keydown={() => selectMenu(idPageNosPartenairesFormations)}>
                    {#if ($storeLanguage == $lang_fr)}
                    {namePageNosPartenairesFormations}
                    {:else}
                    Our partners training
                    {/if}
                </div>
                <div class="menu__spacer">&nbsp;</div>
            </div>
        </div>
        <div class="menu">
            <div class="menu__item" class:menu__item--active={$storeCurRoute == idPageEcosystem} on:click={() => selectMenu(idPageEcosystem)} on:keydown={() => selectMenu(idPageEcosystem)}>
                {#if ($storeLanguage == $lang_fr)}
                {namePageEcosystem}
                {:else}
                API ecosystem
                {/if}
            </div>
        </div>
        <div class="menu">
            <div class="menu__item menu__item__notclic">
                {#if ($storeLanguage == $lang_fr)}
                Nous rejoindre
                {:else}
                Join us
                {/if}
            </div>
            <div class="{isSubMenuClicked ? 'subMenu subMenu--clicked' : 'subMenu'}">
                <div class="subMenu__spacer">
                    <div class="subMenu__spacer__line">&nbsp;</div>
                </div>
                <div class="subMenu__item" class:subMenu__item--active={$storeCurRoute == idPageDevenirPartenaire} on:click={() => selectMenu(idPageDevenirPartenaire)} on:keydown={() => selectMenu(idPageModifPassword)}>
                    {#if ($storeLanguage == $lang_fr)}
                    {namePageDevenirPartenaire}
                    {:else}
                    To become a partner
                    {/if}
                </div>
                <div class="subMenu__item" class:subMenu__item--active={$storeCurRoute == idPageDevenirMembre} on:click={() => selectMenu(idPageDevenirMembre)} on:keydown={() => selectMenu(idPageDevenirMembre)}>
                    {#if ($storeLanguage == $lang_fr)}
                    {namePageDevenirMembre}
                    {:else}
                    To become a member
                    {/if}
                </div>
                <div class="menu__spacer">&nbsp;</div>
            </div>
        </div>
        <div class="menu">
            <div class="menu__item" class:menu__item--active={$storeCurRoute == idPageBlog || $storeCurRoute == idPageArticle} on:click={() => selectMenu(idPageBlog)} on:keydown={() => selectMenu(idPageBlog)}>
                {#if ($storeLanguage == $lang_fr)}
                {namePageBlog}
                {:else}
                {namePageBlog}
                {/if}
            </div>
            {#if ($storeIsLogin && ($storeUserLogin.user_type == 1 || $storeUserLogin.user_type == 3))}
            <div class="{isSubMenuClicked ? 'subMenu subMenu--clicked' : 'subMenu'}">
                <div class="subMenu__spacer">
                    <div class="subMenu__spacer__line">&nbsp;</div>
                </div>
                <div class="subMenu__item" class:subMenu__item--active={$storeCurRoute == idPageBlog} on:click={() => selectMenu(idPageMyArticles)} on:keydown={() => selectMenu(idPageMyArticles)}>
                    {#if ($storeLanguage == $lang_fr)}
                    Mes articles
                    {:else}
                    My articles
                    {/if}
                </div>
                <div class="menu__spacer">&nbsp;</div>
            </div>
            {/if}
        </div>
        <div class="menu">
            {#if $storeIsLogin}
            <div class="menu__item" class:menu__item--active={$storeCurRoute == idPageUserAccount} on:click={() => selectMenu(idPageUserAccount)} on:keydown={() => selectMenu(idPageUserAccount)}>
                {#if ($storeLanguage == $lang_fr)}
                Mon compte
                {:else}
                My account
                {/if}
            </div>
            <div class="{isSubMenuClicked ? 'subMenu subMenu--clicked' : 'subMenu'}">
                <div class="subMenu__spacer">
                    <div class="subMenu__spacer__line">&nbsp;</div>
                </div>
                <div class="subMenu__item" class:subMenu__item--active={$storeCurRoute == idPageLogin} on:click={() => disconnect()} on:keydown={() => disconnect()}>
                    {#if ($storeLanguage == $lang_fr)}
                    Déconnexion
                    {:else}
                    Logout
                    {/if}
                </div>
                <div class="menu__spacer">&nbsp;</div>
            </div>
            {:else}
            <div class="menu__item" class:menu__item--active={$storeCurRoute == idPageLogin} on:click={() => selectMenu(idPageLogin)} on:keydown={() => selectMenu(idPageLogin)}>
                {#if ($storeLanguage == $lang_fr)}
                {namePageLogin}
                {:else}
                Log in
                {/if}
            </div>
            {/if}
        </div>
        <div class="menu">
            <div class="menu__item" on:click={() => toggleLang()} on:keydown={() => toggleLang()}>
                {#if ($storeLanguage == $lang_fr)}
                    <img class="menu__item__img" src="../assets/images/flag-en.png" alt="drapeau Grande Bretagne" title="to english">
                {:else}
                    <img class="menu__item__img" src="../assets/images/flag-fr.png" alt="drapeau France" title="en français">
                {/if}
            </div>
        </div>
    </nav>    
</div>
